import axios_ from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment'
import UUID from 'uuid/v4'

moment.locale('pl')

Vue.use(Vuex)

const API_PREFIX = '/back'

let axios

function pad(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

const makeOptions = (payload) => {
    let token

    if (payload) {
        token = `Basic ${btoa(payload.username + ':' + payload.password)}`
    } else {
        token = window.sessionStorage.getItem('x-auth-token')
    }

    return {
        dataType: 'json',
        // responseType: 'json',
        headers: {
            ...token ? {'Authorization': token} : {},
        },
    }
}

const clearAuthSession = () => {
    window.sessionStorage.removeItem('x-auth-token')

    axios = createAxios()
}

const setAuthSession = (token) => {
    window.sessionStorage.setItem('x-auth-token', token)

    axios = createAxios()
}

const logError = ({data='', status='', statusText=''}) => {
    store.dispatch('logError', {
        data,
        status,
        statusText
    })
}

const createAxios = (payload) => {
    const instance = axios_.create(makeOptions(payload))

    instance.interceptors.response.use(response => {
        const expires_in = parseInt(localStorage.getItem('expires_in'));
        if (expires_in) {
            store.dispatch('resetExpiresIn', expires_in)
        }
        return response
    }, error => {
        logError(error.response);

        if (error.response.status === 401) {
            clearAuthSession()

            store.dispatch('login')
        }
        // Do something with response error
        return Promise.reject(error)
    })

    return instance
}

axios = createAxios()

const ID_MAP = {
    pole: 'poleId',
    article: 'articleId',
    survey: 'surveyId',
    optionalTask: 'optionalTaskId',
    user: 'userId',
    file: 'id',
    badge: 'badgeId',
    category: 'category',
    activity: 'activityTypeId',
    pushTemplate: 'id',
    extuser: 'userId',
    kbCategory: 'kbCategory',
    csv: 'contentId',
    achievement: 'achievementId',
    achievementRule: 'achievementId',
}

const URL_MAP = {
    pole: 'poles',
    article: 'articles',
    survey: 'surveys',
    optionalTask: 'poles/optTask',
    user: 'users',
    file: 'content/file',
    badge: 'poles/badge',
    csv: 'content',
    category: 'category',
    activity: 'activities/types',
    pushTemplate :'push/templates',
    pushMessage: 'push/messages/allUsers',
    extuser: 'extusers',
    kbCategory: 'category/kb',
    achievement: 'achievements',
    achievementRule: 'achievements/{achievementId}/rules',
}

const LANG = {
    pole: 'biegun',
    article: 'artykuł',
    survey: 'ankieta',
    optionalTask: 'zadanie uzupełniające',
    user: 'użytkownik',
    file: 'plik',
    badge: 'odznaka',
    csv: 'dane',
    category: 'kategoria',
    activity: 'aktywność',
    pushTemplate :'szablon PUSH',
    pushMessage: 'wiadomość PUSH',
    extuser: 'użytkownik mobilny',
    kbCategory: 'kategoria bazy wiedzy',
    achievement: 'osięgnięcie',
    achievementRule: 'reguła osiągnięcia',
}

var store = new Vuex.Store({
    // strict: true,
    state: {
        BASE_POLE_ID: '11db9b5a-0000-1111-2222-a1814b23a376',
        showLeftMenu: true,
        showRightMenu: false,
        rightMenuWidth: 400,
        me: {},
        loggedIn: undefined,
        loginExpiryTime: undefined,
        loginExpiryTimerId: -1,
        logoutIn: undefined,
        timeToLogoutString: '',
        pole: [],
        file: [],
        tasks: [],
        article: [],
        badge: [],
        tasklets: [],
        pictures: [],
        users: [],
        activity: [],
        optionalTask: [],
        extuser: [],
        loadingUsers: false,
        audio: [],
        video: [],
        survey: [],
        voicecommands: [],
        articles: [],
        articlesFetching: false,
        articlesFetched: false,
        articlesFetchFailed: false,
        csvInfo: undefined,
        csv: [],
        category: [],
        kbCategory: [],
        pushTemplate: [],
        achievement: [],
        achievementRule: [],
        errors: [],
        unpublishableModels: [
            'category', 'kbCategory', 'csv', 'optionalTask'

        ],
        RS: {},
        STEP_NAMES: {
            1: 'Odkryj swój biegun',
            2: 'Mapa drogi',
            3: 'Najlepszą praktyką jest dobra teoria',
            4: 'Wyjście poza schemat',
            5: 'Wizualizacja jako metoda przygotowań',
            6: 'Start',
            7: 'Droga jest ważniejsza niż cel',
            8: 'Dwa bieguny',
            9: 'Nie osiedlaj się na biegunie',
            10: 'Poznaj samego siebie',
        },
        MEDIA_PREFIX: '',
        MEDIA_PREFIX_FOR_IMG: '',
        notifications: [],
    },
    mutations: {
        patch (state, data) {
            for (const key of Object.keys(data)) {
                state[key] = data[key];
            }
        },
        all (state, payload) {
            state[payload.what] = payload.items
        },
        one (state, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            const exists = state[payload.what].find(
                item => item[idAttr] === id) !== undefined
            if (exists) {
                state[payload.what] = state[payload.what].map(item => {
                    if (item[idAttr] === id) {
                        return payload.item
                    } else {
                        return item
                    }
                })
            } else {
                state[payload.what].push(payload.item)
            }
        },
        remove (state, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            state[payload.what] = state[payload.what].filter(
                item => item[idAttr] !== id)
        },

        loggedIn (state, isLoggedIn) {
            state.loggedIn = isLoggedIn
        },

        //
        // users mutations
        //
        setUsers (state, users) {
            state.users = users
        },
        fetchingUsers (state, value) {
            state.fetchingUser = value
        },

        //
        // tasks
        //
        setTask (state, value) {
            state.tasks = value.map(v => {
                return {
                    ...v,
                }
            })
        },
        updateTask: (state, value) => {
            const index = state.tasks.findIndex(
                p => p.optionalTaskId === value.optionalTaskId)
            if (index != -1) {
                state.tasks.splice(index, 1, {
                    ...value,
                })
            } else {
                state.tasks = [
                    ...state.tasks, {
                        ...value,
                    }]
            }
        },
        deleteTask: (state, value) => {
            state.tasks = state.tasks.filter(
                v => v.optionalTaskId !== value.optionalTaskId)
        },

        //
        // tasklet
        //
        setTasklet (state, value) {
            state.tasklets = value.map(v => {
                return {
                    ...v,
                }
            })
        },
        updateTasklet: (state, value) => {
            const index = state.tasklets.findIndex(p => p.id === value.id)
            if (index != -1) {
                state.tasklets.splice(index, 1, {
                    ...value,
                })
            } else {
                state.tasklets = [
                    ...state.tasklets, {
                        ...value,
                    }]
            }
        },
        deleteTasklet: (state, value) => {
            state.tasklets = state.tasklets.filter(v => v.id !== value.id)
        },

        //
        // article
        //
        setArticle (state, value) {
            state.articles = value.map(v => {
                return {
                    ...v,
                    type: 'article',
                }
            })
        },
        updateArticle: (state, value) => {
            value = {...value}
            delete value.isNew

            const index = state.articles.findIndex(
                p => p.articleId === value.articleId)
            if (index != -1) {
                state.articles.splice(index, 1, {
                    ...value,
                })
            } else {
                state.articles = [
                    ...state.articles, {
                        ...value,
                    }]
            }
        },
        deleteArticle: (state, value) => {
            state.articles = state.articles.filter(
                v => v.articleId !== value.articleId)
        },

        //
        // voice commands
        //
        setVoicecommand (state, value) {
            state.voicecommands = value.map(v => {
                return {
                    ...v,
                }
            })
        },
        updateVoicecommand: (state, value) => {
            const index = state.voicecommands.findIndex(p => p.id === value.id)
            if (index !== -1) {
                state.voicecommands.splice(index, 1, {
                    ...value,
                })
            } else {
                state.voicecommands = [
                    ...state.voicecommands, {
                        ...value,
                    }]
            }
        },
        deleteVoicecommand: (state, value) => {
            state.voicecommands = state.voicecommands.filter(
                v => v.id !== value.id)
        },

        //
        // ext users mutations
        //
        lockExtuser (state, {userId, blockedUntil}) {
            state.extuser = state.extuser.map(u => {
                if (u.userId === userId) {
                    return {
                        ...u,
                        blocked: true,
                        blockedUntil
                    }
                } else {
                    return u
                }
            })
        },
        unlockExtuser (state, {userId}) {
            state.extuser = state.extuser.map(u => {
                if (u.userId === userId) {
                    return {
                        ...u,
                        blocked: false,
                    }
                } else {
                    return u
                }
            })
        },
        me (state, me) {
            state.me = me
        },
        showLeftMenu (state, value) {
            state.showLeftMenu = value
        },
        showRightMenu (state, value) {
            state.showRightMenu = value
        },
        MEDIA_PREFIX (state, value) {
            state.MEDIA_PREFIX = value
        },
        MEDIA_PREFIX_FOR_IMG (state, value) {
            state.MEDIA_PREFIX_FOR_IMG = value
        },
        csvInfo (state, value) {
            state.csvInfo = {
                ...value,
                uploadTs: moment(value.uploadTs),
            }
        },
        fetching (state, {what, id}) {
            let key

            if (id !== undefined) {
                key = `fetching-${what}-${id}`
            } else {
                key = `fetching-${what}`
            }

            const keyExists = state.hasOwnProperty(key)
            const value = true

            if (keyExists) {
                state[key] = value
            } else {
                Vue.set(state, key, value)
            }
        },
        fetchFailed (state, {what, id}) {
            let key

            if (id !== undefined) {
                key = `${what}-${id}`
            } else {
                key = what
            }

            const keyExists = state.hasOwnProperty(key)
            const value = true

            if (keyExists) {
                state[key] = value
            } else {
                Vue.set(state, key, value)
            }
        },
        RS (state, {key, value}) {
            Vue.set(state.RS, key, value)
        },
        consumeNotification (state, id) {
            state.notifications = state.notifications.filter(x => x.id !== id)
        },
        notify (state, msg) {
            state.notifications = [...state.notifications, {
                ...msg,
                id: UUID()
            }]
        }
    },
    getters: {
        achievementRule (state) {
            return state.achievementRule
        },
        pole (state) {
            return (state.pole || []).map(x => {
                return {
                    ...x,
                    type: 'pole',
                }
            })
        },
        basePole (state) {
            return state.pole.find(p => p.poleId === state.BASE_POLE_ID)
        },
        juniorAnonymousPole(state) {
            return state.pole.filter(
                p => p.phase === 0 && p.group === 'junior' && !p.deleted)[0];
        },
        seniorAnonymousPole(state) {
            return state.pole.filter(
                p => p.phase === 0 && p.group === 'senior' && !p.deleted)[0];
        },
        category (state) {
            return state.category.map(c => {
                return {
                    ...c,
                    type: 'category'
                }
            })
        },
        kbCategory (state) {
            return state.kbCategory.map(c => {
                return {
                    ...c,
                    type: 'kbCategory'
                }
            })
        },

        audio (state) {
            return state.file.filter(file => {
                return file.urlPath.endsWith('.mp3')
            }).map(x => {
                return {
                    ...x,
                    src: x.urlPath,
                    type: 'audio',
                }
            })
        },
        video (state) {
            return state.file.filter(file => {
                return file.urlPath.endsWith('.mp4') || file.urlPath.endsWith('.mpg') || file.urlPath.endsWith('.mov')
            }).map(x => {
                return {
                    ...x,
                    src: x.urlPath,
                    type: 'video',
                }
            })
        },
        pictures (state) {
            return state.file.filter(file => {
                return file.urlPath.endsWith('.jpg') ||
                    file.urlPath.endsWith('.png') ||
                    file.urlPath.endsWith('.gif')
            }).map(x => {
                return {
                    ...x,
                    src: x.urlPath,
                    type: 'picture',
                }
            })
        },
        survey (state) {
            return state.survey.map(s => {
                return {
                    ...s,
                    type: 'survey',
                }
            })
        },
        qualifyingSurvey (state, getters) {
            return getters.survey.filter(s => s.qualifying)
        },
        regularSurvey (state, getters) {
            return getters.survey.filter(s => !s.qualifying)
        },
        article (state) {
            return state.article.filter(a => a.kbCategory === undefined).map(s => {
                return {
                    ...s,
                    type: 'article',
                }
            })
        },
        kbArticle (state) {
            return state.article.filter(a => a.kbCategory !== undefined).map(s => {
                return {
                    ...s,
                    type: 'article',
                }
            })
        },
        badge (state) {
            return state.badge.map(b => {
                return {
                    ...b,
                    type: 'badge',
                }
            })
        },
        optionalTask (state) {
            return (state.optionalTask || []).map(b => {
                return {
                    ...b,
                    type: 'optionalTask',
                }
            })
        },
        csv (state) {
            return state.csv
        },
        activity (state) {
            return state.activity.map(m => {
                return {
                    ...m,
                    type: 'activity',
                }
            })
        },
        pushTemplate (state) {
            return state.pushTemplate
        },
        extuser (state) {
            return state.extuser
        },
        publishableComponents (state, getters) {
            return {
                article: getters.article,
                kbArticle: getters.kbArticle,
                pole: getters.pole.filter(p => {
                    return p.poleId !== state.BASE_POLE_ID
                        && p.deleted === undefined
                }),
                survey: getters.survey,
                optionalTask: getters.optionalTask,
                badge: getters.badge,
                activity: getters.activity,
                category: getters.category,
                kbCategory: getters.kbCategory,
            }
        },
        achievement (state) {
            return state.achievement
        }
    },
    actions: {
        create (context, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            const rsKey = `${payload.what}-${id}`

            if (context.state.RS[rsKey] === 'create_done' && !payload.force) {
                return Promise.resolve()
            }

            let url = URL_MAP[payload.what]

            const pathParamsToReplace = Object.keys(payload.pathParams || {})
            pathParamsToReplace.forEach(param => {
                if (url.indexOf(`{${param}}`) !== -1) {
                    url = url.replace(`{${param}}`, payload.pathParams[param])
                }
            })

            this.commit('RS', {key: rsKey, value: 'create_ongoing'})
            return axios.post(`${API_PREFIX}/${url}`, payload.item).
                then(() => {
                    if (! payload.dontfetch) {
                        return context.dispatch('fetch', payload).then(() => {
                            this.commit('notify', {
                                type: 'positive',
                                message: `${LANG[payload.what]} utworzony`
                            })

                            this.commit('RS', {key: rsKey, value: 'create_done'})
                            return payload
                        }).catch((error/*error, xhr, response*/) => {
                            this.commit('notify', {
                                type: 'negative',
                                message: `${LANG[payload.what]} nie został utworzony`
                            })

                            this.commit('RS', {key: rsKey, value: 'create_failed'})
                            throw(error);
                        })
                    } else {
                        this.commit('notify', {
                            type: 'positive',
                            message: `${LANG[payload.what]} utworzony`
                        })

                        this.commit('RS', {key: rsKey, value: 'create_done'})

                        return Promise.resolve()
                    }
                }).
                catch((error/*error, xhr, response*/) => {
                    this.commit('RS', {key: rsKey, value: 'create_failed'})

                    this.commit('notify', {
                        type: 'negative',
                        message: `${LANG[payload.what]} nie został utworzony`
                    })

                    throw(error);
                })
        },
        update (context, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            const rsKey = `${payload.what}-${id}`

            let url = URL_MAP[payload.what]

            const pathParamsToReplace = Object.keys(payload.pathParams || {})
            pathParamsToReplace.forEach(param => {
                if (url.indexOf(`{${param}}`) !== -1) {
                    url = url.replace(`{${param}}`, payload.pathParams[param])
                }
            })

            this.commit('RS', {key: rsKey, value: 'update_ongoing'})
            return axios.put(`${API_PREFIX}/${url}/${id}`,
                payload.item).
                then(() => {
                    if (! payload.dontfetch) {
                        return context.dispatch('fetch', {
                            ...payload,
                            force: true,
                        }).then(() => {
                            this.commit('RS', {key: rsKey, value: 'update_done'})

                            this.commit('notify', {
                                type: 'positive',
                                message: `${LANG[payload.what]} zaktualizowany`
                            })
                        }).catch((error/*error, xhr, response*/) => {
                            this.commit('RS', {key: rsKey, value: 'update_failed'})

                            this.commit('notify', {
                                type: 'negative',
                                message: `${LANG[payload.what]} nie został zaktualizowany`
                            })

                            throw(error);
                        })
                    } else {
                        this.commit('notify', {
                            type: 'positive',
                            message: `${LANG[payload.what]} zaktualizowany`
                        })
                        return Promise.resolve([]);
                    }
                }).
                catch((error/*error, xhr, response*/) => {
                    this.commit('RS', {key: rsKey, value: 'update_failed'})

                    this.commit('notify', {
                        type: 'negative',
                        message: `${LANG[payload.what]} nie został zaktualizowany`
                    })

                    throw(error);
                })
        },
        fetch (context, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            const rsKey = `${payload.what}-${id}`

            if (context.state.RS[rsKey] === 'fetch_ongoing') {
                return Promise.resolve()
            }

            if (context.state.RS[rsKey] === 'fetch_done' && !payload.force) {
                return Promise.resolve()
            }

            let url = URL_MAP[payload.what]
            const pathParamsToReplace = Object.keys(payload.pathParams || {})
            pathParamsToReplace.forEach(param => {
                if (url.indexOf(`{${param}}`) !== -1) {
                    url = url.replace(`{${param}}`, payload.pathParams[param])
                }
            })

            const params = {
                ...payload.showDeleted ? {showDeleted: true} : {},
                ...payload.showOnlyDeleted ? {showOnlyDeleted: true} : {}
            }

            this.commit('RS', {key: rsKey, value: 'fetch_ongoing'})
            return axios.get(`${API_PREFIX}/${url}/${id}`, {params}).
                then(response => {
                    context.commit('one', {
                        ...payload,
                        item: response.data,
                    })
                    this.commit('RS', {key: rsKey, value: 'fetch_done'})
                }).
                catch((error/*error, xhr, response*/) => {
                    this.commit('RS', {key: rsKey, value: 'fetch_failed'})
                    throw(error);
                })
        },
        fetchAll (context, payload) {
            const rsKey = payload.what

            if (context.state.RS[rsKey] === 'fetch_ongoing') {
                return Promise.resolve()
            }

            if (context.state.RS[rsKey] === 'fetch_done' && !payload.force) {
                return Promise.resolve()
            }

            let url = URL_MAP[payload.what]
            const pathParamsToReplace = Object.keys(payload.pathParams || {})
            pathParamsToReplace.forEach(param => {
                if (url.indexOf(`{${param}}`) !== -1) {
                    url = url.replace(`{${param}}`, payload.pathParams[param])
                }
            })

            const params = {
                ...payload.showDeleted ? {showDeleted: true} : {},
                ...payload.showOnlyDeleted ? {showOnlyDeleted: true} : {}
            }

            this.commit('RS', {key: rsKey, value: 'fetch_ongoing'})
            return axios.get(`${API_PREFIX}/${url}`, {params}).
                then(response => {
                    if (! payload.dontstore) {
                        context.commit('all', {
                            ...payload,
                            items: response.data,
                        })
                    }

                    this.commit('RS', {key: rsKey, value: 'fetch_done'})

                    return response
                }).
                catch((error/*error, xhr, response*/) => {
                    this.commit('RS', {key: rsKey, value: 'fetch_failed'})
                    throw(error);
                })
        },
        /**
         *
         * @param context
         * @param payload {id, what, item, force, soft}
         * @returns {Promise<void>}
         */
        remove (context, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            const rsKey = `${payload.what}-${id}`

            if (context.state.RS[rsKey] === 'remove_done' && !payload.force) {
                return Promise.resolve()
            }

            let url = URL_MAP[payload.what]
            const pathParamsToReplace = Object.keys(payload.pathParams || {})
            pathParamsToReplace.forEach(param => {
                if (url.indexOf(`{${param}}`) !== -1) {
                    url = url.replace(`{${param}}`, payload.pathParams[param])
                }
            })

            this.commit('RS', {key: rsKey, value: 'remove_ongoing'})
            return axios.delete(`${API_PREFIX}/${url}/${id}`).then(() => {
                if (payload.notify === undefined || payload.notify) {
                    this.commit('notify', {
                        type: 'positive',
                        message: `${LANG[payload.what]} usunięty`
                    })
                }

                if (payload.soft) {
                    context.dispatch('fetch', {
                        ...payload,
                        force: true,
                        showDeleted: true
                    }).then(() => {
                        this.commit('RS', {key: rsKey, value: 'remove_done'})
                    })
                } else {
                    context.commit('remove', payload)
                    this.commit('RS', {key: rsKey, value: 'remove_done'})
                }
            }).catch(error => {
                this.commit('notify', {
                    type: 'negative',
                    message: `${LANG[payload.what]} nie został usunięty`
                })
                this.commit('RS', {key: rsKey, value: 'remove_failed'})
                throw(error);
            })
        },
        publish (context, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            const rsKey = `${payload.what}-${id}`
            const url = URL_MAP[payload.what]


            this.commit('RS', {key: rsKey, value: 'publish_ongoing'})
            return axios.post(`${API_PREFIX}/${url}/${id}/publish`).
                then(() => {
                    return context.dispatch('fetch', {
                        what: payload.what,
                        id,
                    }).then(() => {
                        this.commit('notify', {
                            type: 'positive',
                            message: `Opublikowano: ${LANG[payload.what]}`
                        })

                        this.commit('RS', {key: rsKey, value: 'publish_done'})
                    }).catch(error => {
                        this.commit('notify', {
                            type: 'nagative',
                            message: `Błąd publikacji: ${LANG[payload.what]}`
                        })

                        this.commit('RS', {key: rsKey, value: 'publish_failed'})
                        throw(error);
                    })
                }).
                catch((error/*error, xhr, response*/) => {
                    this.commit('notify', {
                        type: 'nagative',
                        message: `Błąd publikacji: ${LANG[payload.what]}`
                    })

                    this.commit('RS', {key: rsKey, value: 'publish_failed'})
                    throw(error);
                })
        },
        unpublish (context, payload) {
            const idAttr = ID_MAP[payload.what]
            const id = payload.id || payload.item[idAttr]

            const rsKey = `${payload.what}-${id}`
            const url = URL_MAP[payload.what]

            this.commit('RS', {key: rsKey, value: 'unpublish_ongoing'})
            return axios.post(`${API_PREFIX}/${url}/${id}/unpublish`).
                then(() => {
                    return context.dispatch('fetch', {
                        what: payload.what,
                        id,
                    }).then(() => {
                        if (payload.notify === undefined || payload.notify) {
                            this.commit('notify', {
                                type: 'positive',
                                message: `Cofnięto publikację: ${LANG[payload.what]}`
                            })
                        }

                        this.commit('RS', {key: rsKey, value: 'unpublish_done'})
                    }).catch(error => {
                        this.commit('notify', {
                            type: 'nagative',
                            message: `Błąd cofania publikacji: ${LANG[payload.what]}`
                        })

                        this.commit('RS', {key: rsKey, value: 'unpublish_failed'})
                        throw(error);
                    })
                }).
                catch((error/*error, xhr, response*/) => {
                    this.commit('notify', {
                        type: 'nagative',
                        message: `Błąd cofania publikacji: ${LANG[payload.what]}`
                    })

                    this.commit('RS', {key: rsKey, value: 'unpublish_failed'})
                    throw(error);
                })
        },

        //
        // users
        //
        fetchUsers (context) {
            context.commit('fetchingUsers', true)
            axios.get(`${API_PREFIX}/users`).then(response => {
                context.commit('setUsers', response.data)
                context.commit('fetchingUsers', false)
            })
        },
        deleteUser (context, userId) {
            axios.delete(`${API_PREFIX}/users/${userId}`).
                then(() => {
                    context.dispatch('fetchUsers')
                }).
                catch((/*error, response*/) => {
                    //
                })
        },
        addUser (context, data) {
            axios.post(`${API_PREFIX}/users`, {
                userId: data.userId,
                login: data.login,
                password: data.password,
                roles: data.roles,
            }).then(() => {
                context.dispatch('fetchUsers')
            })
        },
        updateUser (context, data) {
            axios.put(`${API_PREFIX}/users/${data.userId}`, {
                ...context.state.users.find(u => u.userId === data.userId),
                ...data.login ? {login: data.login} : {},
                ...data.password ? {password: data.password} : {},
                ...data.roles ? {roles: data.roles} : {},
            }).then(() => {
                context.dispatch('fetchUsers')
            })
        },
        login (context, payload) {
            axios = createAxios(payload)

            axios.post(`${API_PREFIX}/users/login`).
                then(response => {
                    const token = 'Bearer ' + response.data.access_token

                    const expires_in = response.data.expires_in; // seconds from now
                    localStorage.setItem('expires_in', expires_in);
                    context.dispatch('resetExpiresIn', expires_in)

                    setAuthSession(token)

                    context.commit('loggedIn', true)
                    context.commit('patch', {
                        errors: []
                    })

                    // do it here so that we get 'me'
                    context.dispatch('checkAuth')
                }).
                catch((e) => {
                    throw(e)
                })
        },
        resetExpiresIn ({dispatch}, expires_in) {
            const expiryDate = new Date(new Date().getTime() + expires_in * 1000);
            const expiryDateString = expiryDate.toISOString();

            window.sessionStorage.setItem('expiryDateString', expiryDateString);

            dispatch('loginExpiryTime', {
                time: expiryDate
            })
        },
        loginExpiryTime ({state, dispatch, commit}, {time}) {
            if (state.loginExpiryTimerId !== -1) {
                clearInterval(state.loginExpiryTimerId);
            }

            commit('patch', {
                loginExpiryTime: time,
                loginExpiryTimerId,
            })

            const loginExpiryTimerId = setInterval(() => {
                dispatch('updateLogoutIn')
            }, 1000);
        },
        updateLogoutIn ({state, commit, dispatch}) {
            const now = new Date();
            const end = state.loginExpiryTime;
            const diffInSeconds = parseInt((end - now) / 1000);


            const hours = parseInt(diffInSeconds / 3600)
            const minutes = parseInt(diffInSeconds / 60)
            const seconds = diffInSeconds % 60;

            let s;
            if (hours) {
               s = `${pad(hours,2)}:${pad(minutes,2)}:${pad(seconds,2)}`
            } else {
                s = `${pad(minutes,2)}:${pad(seconds,2)}`
            }

            if (diffInSeconds < 0) {
                clearInterval(state.loginExpiryTimerId);
                commit('patch', {
                    loginExpiryTimerId: -1
                })
                dispatch('clearAfterLogout')
            } else {
                commit('patch', {
                    logoutIn: diffInSeconds,
                    timeToLogoutString: s
                });
            }
        },
        logout ({dispatch}) {
            axios.post(`${API_PREFIX}/users/logout`).then(() => {
                dispatch('clearAfterLogout')
            }).catch((e) => {
                throw(e)
            })
        },
        clearAfterLogout (context) {
            clearAuthSession()
            context.commit('me', {})
            context.commit('loggedIn', false)
        },
        checkAuth (context) {
            axios.get(`${API_PREFIX}/users/me`).then(response => {
                context.commit('me', response.data)
                context.dispatch('fetchClientConf')

                const expiryDateString = window.sessionStorage.getItem('expiryDateString');
                if (expiryDateString) {
                    const expiryDate = new Date(expiryDateString);
                    context.dispatch('loginExpiryTime', {
                        time: expiryDate
                    })
                }

            }).catch((e) => {
                context.commit('loggedIn', false)
                throw(e)
            })
        },
        fetchClientConf (context) {
            axios.get(`${API_PREFIX}/client/conf`).then(response => {
                context.commit('MEDIA_PREFIX', response.data.contentUrlBase)
                context.commit('MEDIA_PREFIX_FOR_IMG', response.data.contentUrlBase.replace('/img', '/200px/img'))

                context.commit('loggedIn', true)
            }).catch((e) => {
                // ...
                throw(e)
            })
        },
        uploadFile (context, {file, progress}) {
            return new Promise((resolve, reject) => {
                const formData = new FormData()
                formData.append('file', file, file.name)

                axios.post(`${API_PREFIX}/content/file/upload`, formData, {
                    onUploadProgress: progressEvent => {
                        const percentCompleted = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total)
                        if (progress) {
                            progress(percentCompleted);
                        }
                    }
                })
                .then(response => {
                    context.dispatch('fetch', {
                        what: 'file',
                        id: response.data.id,
                    })
                    resolve(response.data)
                })
                .catch((e) => {
                    reject(e)
                })
            })
        },
        uploadCsvFile (context, file) {
            return new Promise((resolve, reject) => {
                const formData = new FormData()
                formData.append('file', file.file, file.name)

                axios.post(`${API_PREFIX}/content/uploadContents`, formData).
                    then(response => {
                        resolve(response.data)

                        context.dispatch('fetchCsvInfo')
                    }).
                    catch((e) => {
                        reject(e)
                    })
            })
        },
        fetchCsvInfo (context) {
            return axios.get(`${API_PREFIX}/content/upload/information/newest`).
                then(response => {
                    context.commit('csvInfo', response.data)
                }).
                catch((e) => {
                    throw(e)
                })
        },
        publishFile (context, id) {
            return axios.post(`${API_PREFIX}/content/${id}/publish`)
        },

        //
        // tasks
        //
        fetchTask (context, id) {
            return axios.get(
                `${API_PREFIX}/poles/optTask${id ? '/' + id : ''}`).
                then(value => {
                    if (id) {
                        context.commit('updateTask', value.data)
                    } else {
                        context.commit('setTask', value.data)
                    }
                })
        },
        addTask (context, value) {
            return axios.post(`${API_PREFIX}/poles/optTask`, value,
            ).then(response => {
                context.commit('updateTask', response.data)
            })
        },
        updateTask (context, value) {
            return axios.put(
                `${API_PREFIX}/poles/optTask/${value.optionalTaskId}`, value,
            ).then(response => {
                context.commit('updateTask', response.data)
            })
        },
        deleteTask (context, value) {
            if (value.isNew) {
                context.commit('deleteTask', value)
                return Promise.resolve()
            }

            return axios.delete(
                `${API_PREFIX}/poles/${value.poleId}/steps/${value.poleStepId}/tasks/${value.poleStepTaskId}`).
                then(() => {
                    context.commit('deleteTask', value)
                })
        },
        publishTask (context, optionalTaskId) {
            return axios.post(
                `${API_PREFIX}/poles/optTask/${optionalTaskId}/publish`).
                then(() => {
                    context.dispatch('fetchTask', optionalTaskId)
                })
        },

        //
        // taskslets
        //
        fetchTasklet (context, id) {
            return axios.get(`${API_PREFIX}/tasklet/${id ? id : ''}`).
                then(value => {
                    if (id) {
                        context.commit('updateTasklet', value.data)
                    } else {
                        context.commit('setTasklet', value.data)
                    }
                })
        },
        addTasklet (context, value) {
            return axios.post(`${API_PREFIX}/tasklet`, {
                id: value.id,
                name: value.name,
                description: value.description,
                tasklet: value.tasklet,
                background: value.background,
            }).then(response => {
                context.commit('updateTasklet', response.data)
            })
        },
        updateTasklet (context, value) {
            return axios.put(`${API_PREFIX}/tasklet/${value.id}`, {
                id: value.id,
                name: value.name,
                description: value.description,
                tasklet: value.tasklet,
                background: value.background,
            }).then(response => {
                context.commit('updateTasklet', response.data)
            })
        },
        deleteTasklet (context, value) {
            return axios.delete(`${API_PREFIX}/tasklet/${value.id}`).
                then(() => {
                    context.commit('deleteTasklet', value)
                })
        },

        //
        // voice commands
        //
        fetchVoicecommand (context, id) {
            axios.get(`${API_PREFIX}/voicecommand/${id ? id : ''}`).
                then(value => {
                    if (id) {
                        context.commit('updateVoicecommand', value.data)
                    } else {
                        context.commit('setVoicecommand', value.data)
                    }
                })
        },
        updateVoicecommand (context, value) {
            axios.put(`${API_PREFIX}/voicecommand/${value.id}`, value).
                then(response => {
                    context.commit('updateVoicecommand', response.data)
                })
        },
        deleteVoicecommand (context, value) {
            // here delete will only clear seleced file - it won't remove the record
            // since that should be cnostant
            axios.put(`${API_PREFIX}/voicecommand/${value.id}`, {
                ...value,
                file: undefined,
            }).then(response => {
                context.commit('updateVoicecommand', response.data)
            })
        },

        //
        // articles
        //
        fetchArticle (context, id) {
            return axios.get(`${API_PREFIX}/articles${id ? '/' + id : ''}`).
                then(reponse => {
                    if (id) {
                        context.commit('updateArticle', reponse.data)
                    } else {
                        context.commit('setArticle', reponse.data)
                    }
                }).catch(() => {
                    // ...
                })
        },
        saveArticle (context, article) {
            const method = axios[article.isNew ? 'post' : 'put']
            const articleId = article.articleId

            return method(
                `${API_PREFIX}/articles${article.isNew ? '' : '/' + articleId}`,
                {
                    articleId: article.articleId,
                    version: article.version,
                    group: article.group,
                    title: article.title,
                    summary: article.summary,
                    minUserLevel: article.minUserLevel,
                    canBeTask: article.canBeTask,
                    parts: article.parts.map((p, index) => {
                        return {
                            articlePartId: p.articlePartId,
                            articleId: article.articleId,
                            category: p.category,
                            text: p.text,
                            url: p.url,
                            pos: index,
                            backgroundUrl: p.backgroundUrl,
                            backgroundColor: p.backgroundColor,
                        }
                    }),
                }).then(() => {
                context.commit('updateArticle', article)
            })
        },
        deleteArticle (context, model) {
            return axios.delete(`${API_PREFIX}/articles/${model.articleId}`).
                then(() => {
                    context.commit('deleteArticle', model)
                })
        },

        //
        // ext users actions
        //
        lockExtuser (context, {userId, reason}) {
            const blockedUntil = moment().add(2, 'day').toISOString()
            return axios.post(`${API_PREFIX}/extusers/${userId}/block`, {
                userId,
                reason,
                until: blockedUntil,
            }).then(() => {
                context.commit('lockExtuser', {userId, blockedUntil})
            })
        },
        unlockExtuser (context, {userId}) {
            return axios.post(`${API_PREFIX}/extusers/${userId}/unblock`)
                .then(() => {
                    context.commit('unlockExtuser', {userId})
                })
                .catch(() => {

                })
        },
        resetExtuserPassword (context, userId) {
            return axios.delete(`${API_PREFIX}/extusers/${userId}/passwd`).
                then(resp => {
                    return resp
                })
        },

        giveTrainerRights (context, {userId}) {
            return axios.put(`${API_PREFIX}/extusers/${userId}/privileges`, {
                userId,
                privileges: [
                    'trainer'
                ]
            })
                .then((response) => {
                    return response.data
            })
                .catch((e) => {
                    return e
            })
        },
        logError({state, commit}, error) {
            commit('patch', {
                errors: [...state.errors, error]
            })
        }
    },
})

export default store